// @flow
import React, { Component } from 'react';
import payform from 'payform';

type Props = {
    input: Object,
    meta: Object,
    label: string,
    active: boolean,
    primaryColor: string,
    handleFocus: Function,
};

export default class CardInput extends Component<Props> {
    cardNumber: number;

    componentDidMount() {
        payform.cardNumberInput(this.cardNumber);
    }

    render() {
        const {
            input,
            meta: { touched, error, active },
            label,
        } = this.props;
        let isFieldInvalid = touched && error && !active;

        let focusColor = '#d7dde5';
        let iconColor = '#d7dde5';
        if (this.props.active) {
            focusColor = this.props.primaryColor
                ? this.props.primaryColor
                : '#00aae6';
        }

        if (this.props.active || this.cardNumber) {
            iconColor = this.props.primaryColor
                ? this.props.primaryColor
                : '#00aae6';
        }

        if (isFieldInvalid) {
            iconColor = '#f26f59';
        }

        /* BORDER BOTTOM COLOR */
        let borderBottom = `1px solid ${focusColor}`;
        if (isFieldInvalid) {
            borderBottom = `1px solid #f26f59`;
        }
        let className = isFieldInvalid ? 'invalid' : '';

        return (
            <div className="labelholder">
                <input
                    {...input}
                    id="cnumber"
                    placeholder=" "
                    type="text"
                    name="cardNumber"
                    maxLength="19"
                    ref={ref => (this.cardNumber = ref)}
                    autoComplete="off"
                    className={className}
                    required
                    onFocus={e => {
                        this.props.handleFocus(e);
                        input.onFocus(e);
                    }}
                    onBlur={e => {
                        this.props.handleFocus(e);
                        input.onBlur(e);
                    }}
                    style={{ borderBottom }}
                />
                <i className="ipic_card-front" style={{ color: iconColor }} />
                <label htmlFor="cnumber" id="label-card">
                    {label}
                </label>
                {touched &&
                    error &&
                    !active && (
                        <span className="validation-error">{error}</span>
                    )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/CardInput.js